export default __webpack_public_path__ + "static/media/testador4.54c26db5.png";